<template>
  <v-snackbar
    v-model="notify"
    :timeout="Number(timeout)"
    top
  >
    {{ message }}
    <v-btn
      :color="color"
      text
      @click="notify = false"
    >
      Close
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  props: {
    color: String,
    timeout: Number|String,
    message: String,
  },
  data () {
    return {
      notify: false,
    } 
  },
  metaInfo () {
    return {
      title: 'RSD'
    }
  },
  computed: {
    
  },
  watch: {
    'message' : function (newVal, oldVal) {
      if(newVal != oldVal && newVal) {
        this.notify = true
      }
    }
  }
}
</script>

<style>

#logo {
  max-width: 200px;
  width: 100%;
  padding: 2px;
}

</style>